import Clinics from "./Clinics";
export default Clinics;
